import React, { useEffect } from 'react';
import { useRouteMatch } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { get } from 'lodash';
import { selectDetailsByContentId } from 'reducers/details/selectors';
import { fetchDetails } from 'actions/details';
import { CONTENT_TYPES } from 'constants/content-types';
import withBackSupport from 'components/HOCs/withBackSupport';
import DetailsTariffsPage from './DetailsTariffsPage';

const CONTENT_TYPE_TO_URL = {
  [CONTENT_TYPES.VOD_ASSET]: 'asset',
  [CONTENT_TYPES.TV_SERIES]: 'tvSeries',
};

const DetailsTariffsContainer = () => {
  const match = useRouteMatch();
  const { contentType, contentId } = match.params;
  const dispatch = useDispatch();
  const details = useSelector((state) => selectDetailsByContentId(state, { match }));
  const hasData = !!get(details, ['data']);

  useEffect(() => {
    if (!hasData) {
      dispatch(fetchDetails(contentId, CONTENT_TYPE_TO_URL[contentType], false));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return hasData ? <DetailsTariffsPage data={details.data} /> : null;
};

export default withBackSupport(DetailsTariffsContainer);
